export const eventsStatus = {
  uninitiated: [ '尚未開始', 'uninitiated' ],
  onSale: [ '售票中', 'on sale' ],
  inProgress: [ '活動進行中', 'in progress' ],
  closed: [ '已結束', 'closed' ],
};
